import { render } from "./IjfTemplateDetails.pug?vue&type=template&id=20be72fd&lang=pug"
import script from "./IjfTemplateDetails.js?vue&type=script&lang=js"
export * from "./IjfTemplateDetails.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__